import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const PerformanceChart = ({ data }) => {
  return (
    <div className="w-full h-80" aria-label="Job Performance Analytics Chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis 
            dataKey="month" 
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <YAxis 
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)',
              borderRadius: '6px',
              color: 'var(--color-foreground)'
            }}
          />
          <Legend 
            wrapperStyle={{ fontSize: '12px', color: 'var(--color-foreground)' }}
          />
          <Bar dataKey="applications" fill="var(--color-primary)" name="Applications" radius={[4, 4, 0, 0]} />
          <Bar dataKey="views" fill="var(--color-accent)" name="Views" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PerformanceChart;